/**
 * Cifra grande del panel.
 *
 * El detalle explica contra que se compara: un numero sin referencia no dice si
 * el mes va bien o mal.
 */
import { Icono, type NombreIcono } from '../comunes/Icono';

export interface TarjetaKpiProps {
  icono: NombreIcono;
  etiqueta: string;
  valor: string;
  detalle: string;
  /** Franja de color del borde izquierdo. */
  tono?: 'marca' | 'verde' | 'alerta' | 'wa';
}

export function TarjetaKpi({ icono, etiqueta, valor, detalle, tono = 'marca' }: TarjetaKpiProps) {
  return (
    <li className={tono === 'marca' ? 'kpi' : `kpi ${tono}`}>
      <p className="et">
        <Icono nombre={icono} />
        {etiqueta}
      </p>
      <p className="v">{valor}</p>
      <p className="d">{detalle}</p>
    </li>
  );
}
